import React from 'react';
import LandingPage from './Pages/LandingPage';
import './index.css';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;